// src/api/config.js
// Configurazione per ambiente. Nessun dominio hardcoded nei componenti (Specifica v1.1, §3.2, §7).
//
// NOTA — porting da Vite a CRA (create-react-app) per l'integrazione nel
// frontend TalentGPT esistente: import.meta.env non è supportato da CRA/webpack,
// sostituito con process.env.REACT_APP_* (prefisso obbligatorio in CRA).
//
// MOCK_MODE: protegge SOLO il Self-Assessment pubblico (scope='sa' in
// useKmClient.js). Resta "true" di default — POST /sa/message è ancora
// "non verificato" nel Collaudo 20260907_2.docx (a differenza di
// /sa/open, che è confermato 200), quindi non lo tocco finché non lo
// verifico a parte.
// Passare a "false" via REACT_APP_KM_MOCK_MODE solo dopo aver verificato
// il flusso conversazionale reale.

export const KM_CONFIG = {
  MOCK_MODE: (process.env.REACT_APP_KM_MOCK_MODE ?? 'true') === 'true',

  // Mock per Esperienze/Ricerca/Schede (scope='km' in useKmClient.js).
  // Separato da MOCK_MODE apposta: queste pagine sono state riscritte e
  // verificate sul contratto reale il 18/09 (Collaudo 20260907_2.docx,
  // §6.9/B.5/B.6) — possono passare al backend vero senza toccare il
  // Self-Assessment pubblico, ancora protetto da MOCK_MODE.
  // Default FALSE dal 18/09. Passare a "true" via
  // REACT_APP_KM_KM_MOCK_MODE solo per tornare ai dati mock locali.
  KM_MOCK_MODE: (process.env.REACT_APP_KM_KM_MOCK_MODE ?? 'false') === 'true',

  // Mock SOLO per il pannello/console Self-Assessment su risorsa (nuova
  // integrazione reale). Separato da MOCK_MODE per non toccare Self-
  // Assessment pubblico / Esperienze / Ricerca, già collaudati in demo.
  // Default FALSE dal 18/09: contratto reale verificato (Collaudo
  // 20260907_2.docx, Appendici D/E) e testato dal vivo con Daniele.
  // Passare a "true" via REACT_APP_KM_HR_CONSOLE_MOCK_MODE solo per
  // ri-collaudare UI/stati con le fixture DEV_ locali, non per la demo.
  HR_CONSOLE_MOCK_MODE: (process.env.REACT_APP_KM_HR_CONSOLE_MOCK_MODE ?? 'false') === 'true',

  // Feature flag richiesto da Daniele Feola il 23/09 — separa "il codice
  // esiste" da "è certificato pronto". I tre bottoni di invio dentro
  // MultiFitting (Candidature dirette, Pool, Console HR D1) chiamano
  // /hr/invite, che richiede fit_score — oggi ferma a giugno 2026
  // nell'ambiente di test. Finché Monaco non certifica il refresh (con i
  // due ID di controllo concordati), questi bottoni restano visibili ma
  // disattivati, con una nota — non nascosti (il dato sotto è comunque
  // reale e utile), non lasciati cliccabili a vuoto.
  // Passare a "true" via REACT_APP_KM_MULTIFITTING_INVIO_SA_ABILITATO
  // solo dopo la certificazione esplicita di Monaco.
  // Riacceso il 24/09 — certificato da Monaco (32 righe fit_score su 8
  // annunci, 590/590 test superati, prova deterministica) e riverificato
  // in autonomia con query diretta: 32 totali, 4 per l'annuncio 685192021,
  // combacia esattamente. Condizione posta qui sopra soddisfatta.
  MULTIFITTING_INVIO_SA_ABILITATO: (process.env.REACT_APP_KM_MULTIFITTING_INVIO_SA_ABILITATO ?? 'true') === 'true',

  API_BASE_URL: process.env.REACT_APP_KM_API_BASE_URL || 'https://test.isaitalia.ai/api/km',
  PUBLIC_SA_PATH: process.env.REACT_APP_KM_PUBLIC_SA_PATH || '/self-assessment',
  FEATURE_ENABLED: (process.env.REACT_APP_KM_FEATURE_ENABLED ?? 'true') === 'true',
  ADMIN_ENABLED: (process.env.REACT_APP_KM_ADMIN_ENABLED ?? 'false') === 'true',

  // Timeout (Specifica v1.1, §7)
  TIMEOUT_STANDARD_MS: 30_000,
  TIMEOUT_LLM_MS: 300_000, // operazioni LLM documentate (es. /kl/ask), osservato fino a ~238s

  // Limiti noti (Specifica v1.1, §7.1)
  LONGLIST_MAX_LIMIT: 200,
  KL_SEARCH_MIN_QUERY_LEN: 2,
  KL_SEARCH_DEFAULT_K: 8,
  KL_SEARCH_MAX_K: 30,
  ADMIN_AUDIT_MAX_LIMIT: 500,
  ADMIN_KPI_MAX_MONTHS: 36,

  // Scadenza Self-Assessment (Analisi Funzionale v1.3, V33)
  SA_EXPIRY_DAYS: 30,
};
